import { PickerProjectI } from "components/Pages/Inbox/Picker/models/models.js";
import { useStore as getStore } from "../../utils/useStore.js";
import pickerFactory from "./pickerFactory.ts";
import queryString from "query-string";

const { pn } = queryString.parse(window.location.search) as { pn?: string };

export interface PickerStateI {
  pickerMailList: PickerProjectI[];
  isPickerFetching: boolean;
  projectsQuantity: {
    totalActive: number;
    totalArchive: number;
    Active?: {
      Disabled: 0;
      new: 0;
      Selected: 0;
      Selecting: 0;
      "View Only": 0;
      "Waiting for selecting": 0;
    };
  };
  currentPage: number;
  statusFilters: number[];
  searchTerm: string;
  iFrameLink: string;
  sort: "asc" | "desc";
}

let picker: PickerStateI = {
  pickerMailList: [],
  isPickerFetching: true,
  projectsQuantity: {
    totalActive: 0,
    totalArchive: 0,
  },
  currentPage: pn ? +pn : 1,
  statusFilters: [],
  searchTerm: "",
  iFrameLink: "",
  sort: "desc",
};

const initialState = () => picker;

const [PickerProvider, usePicker, withPicker] = getStore(
  pickerFactory,
  initialState,
  "Picker"
);

export const userInitState = initialState();

export { PickerProvider, usePicker, withPicker };

export default PickerProvider;
